import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/legacy_authorization_resource_user_relationship_type_resource.rb
// Registered from the systemic missing-schema audit (the #9130/#8988 class:
// an API-emittable JSON:API type the FE manifest never registered). Legacy
// admin/PSLF-tooling endpoint; the belongsTo target
// legacy-authorization-resource-endpoint resolves lazily via LegacyMode.
const LegacyAuthorizationResourceUserRelationshipTypeSchema = withDefaults({
  type: 'legacy-authorization-resource-user-relationship-type',
  fields: [
    { kind: 'attribute', name: 'userRelationshipTypeId' },
    { kind: 'attribute', name: 'resourceId' },
    { kind: 'attribute', name: 'updatedAt' },
    {
      kind: 'belongsTo',
      name: 'legacyAuthorizationResourceEndpoint',
      type: 'legacy-authorization-resource-endpoint',
      options: { async: false, inverse: null },
    },
  ],
});

export default LegacyAuthorizationResourceUserRelationshipTypeSchema;
